import React from "react";

import { Button, CircularProgress } from "@mui/material";

export const LoadingButtonType = ({ children, loading, disabled, ...rest }) => {
  return (
    <Button
      disableTouchRipple
      style={{
        cursor: loading ? "progress" : "pointer",
      }}
      disabled={disabled || loading}
      variant="contained"
      {...rest}
    >
      {loading ? (
        <CircularProgress size="20px" style={{ color: "white" }} />
      ) : (
        children
      )}
    </Button>
  );
};
